package ui.composables

import models.ScrollSnapshot


const val PAGE_SIZE = 4
val ScrollSnapshot.firstItemScrollProgress: Float
    get() {
        if (index != 0) return 1f
        val firstItem = visibleItems.firstOrNull() ?: return 0f

        return (offset.toFloat() / firstItem.size)
            .coerceIn(0f, 1f)
    }

fun ScrollSnapshot.scrollProgressFor(targetIndex: Int): Float {
    if (index > targetIndex) return 1f

    val item = visibleItems.firstOrNull { it.index == targetIndex }
        ?: return 0f

    return 1f - (
            (item.offset + item.size).toFloat() /
                    (viewportHeightPx + item.size)
            ).coerceIn(0f, 1f)
}

sealed class PageItem {
    data class Page(val page: Int) : PageItem()
    data object Ellipsis : PageItem()
}